import createFencePricingModule from "./fence-pricing-module";

// Pricing that lives in the new configurator's own db, reached through the HUB API proxy.
export default createFencePricingModule("api/configurator-app/");
